// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_2l-1";
export var movingGradient = "_2l-4";
export var movingGradientBlock = "_2l-2";
export var skeleton = "_2l-0";
export var skeletonText = "_2l-3";